import { useEffect, useState } from 'react';
import ReactTooltip from 'react-tooltip';
import JsonQuery from 'json-query';
import {
    types as commonTypes,
    utils as commonUtils,
    hooks as commonHooks,
} from '@sitebuilder/common';
import { isLocalStorageAccessible } from '../utils';

interface WidgetProperties extends commonTypes.WidgetInstanceProps {
    dataContext: any;
    copyBtnTransformFunc?: string;
    copyBtnDataKey?: string;
    copyBtnLocalStorageItemName?: string;
    copyOnHoverText?: string;
    copyButtonText?: string;
    copyButtonTooltipTextColor?: string;
    copyButtonTooltipBgColor?: string;
    params?: URLSearchParams;
}

export default function EmailContainer(props: WidgetProperties) {
    const {
        dataContext,
        copyBtnDataKey,
        copyBtnTransformFunc,
        copyBtnLocalStorageItemName,
        copyOnHoverText,
        copyButtonText,
        copyButtonTooltipTextColor,
        copyButtonTooltipBgColor,
        params,
    } = props;
    const data = copyBtnDataKey
        ? JsonQuery(`${copyBtnDataKey}`, { data: dataContext }).value
        : dataContext;
    const i18n = commonHooks.useLocalization();
    const storageName = copyBtnLocalStorageItemName || 'favorites';
    const [copyHoverText, setCopyHoverText] = useState(i18n.format(copyOnHoverText, data));

    const {
        fundList: { selectedList },
    } = commonHooks.useAppContext();

    let copyText = 'Copied text!';
    let copyBtnText = i18n.format(copyButtonText, data) || i18n.t('copy');

    if (copyBtnTransformFunc) {
        const transformFunctionName = `${props.widgetInstanceId}-transform`;
        const _isLocalStorageAccessible: boolean = isLocalStorageAccessible();

        const transformedData = commonUtils.transformDataWithGlobals(
            transformFunctionName,
            copyBtnTransformFunc,
            {
                data,
                _isLocalStorageAccessible,
                storageName,
                params,
            }
        );

        if (typeof transformedData === 'string') {
            copyText = transformedData;
        } else {
            copyText = transformedData.copyText;
            copyBtnText = transformedData.copyBtnText;
        }
    }

    const copyToClipBoard = () => {
        navigator.clipboard.writeText(copyText);
        setCopyHoverText(i18n.t('copied_hover_text'));
    };

    useEffect(() => {
        // updated text back if selected list is updated
        setCopyHoverText(i18n.format(copyOnHoverText, data));
    }, [selectedList]);

    return (
        <>
            <div
                className="copy-container"
                data-tip
                data-for="copy-tooltip"
                data-text-color={copyButtonTooltipTextColor || '#fff'}
                data-background-color={copyButtonTooltipBgColor || '#000'}
            >
                {/* key property is added for button to fix
                re-rendering issue on server side */}
                <button
                    key={`copy-btn-${new Date().getTime()}`}
                    onClick={copyToClipBoard}
                    dangerouslySetInnerHTML={{ __html: copyBtnText }}
                />
            </div>
            <ReactTooltip id="copy-tooltip" place="top" effect="solid" className="copy-tooltip">
                {copyHoverText}
            </ReactTooltip>
        </>
    );
}
